"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _projectType = require("@/api/project/projectType");
var _project = require("@/api/project/project");
var _public = require("@/api/public/public");
var _fileUpload = _interopRequireDefault(require("@/components/fileUpload.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    FileUpload: _fileUpload.default
  },
  data: function data() {
    return {
      majorList: [],
      loading: false,
      // 文件列表
      fileList: [],
      // 添加材料的列表
      mateList: [{
        id: "",
        materialName: "",
        endTime: "",
        startTime: ""
      }],
      list: [],
      yearList: [{
        name: "2021",
        value: "2021"
      }, {
        name: "2022",
        value: "2022"
      }, {
        name: "2023",
        value: "2023"
      }, {
        name: "2024",
        value: "2024"
      }, {
        name: "2025",
        value: "2025"
      }, {
        name: "2026",
        value: "2026"
      }, {
        name: "2027",
        value: "2027"
      }, {
        name: "2028",
        value: "2028"
      }, {
        name: "2029",
        value: "2029"
      }, {
        name: "2030",
        value: "2030"
      }],
      typeList: [{
        keyData: "中职",
        valueData: "1"
      }, {
        keyData: "高职",
        valueData: "2"
      }, {
        keyData: "本科",
        valueData: "3"
      }],
      form: {
        matchName: "",
        //项目名称
        matchType: "",
        //项目类型
        matchYear: "",
        //项目年份
        // checkList: ["教育局"], //项目
        isNeedForm: 0,
        //是否需要报名表
        isNeedCheckForm: 1,
        //
        materialListParamList: [{
          id: "",
          materialName: "",
          startTime: "",
          endTime: ""
        }],
        //材料设置
        matchWorkFormRuleList: [{
          name: "",
          startTime: "",
          endTime: ""
        }],
        //作品清单列表
        endTime: "2022-03-31 23:59:59",
        //结束时间
        schoolType: "",
        //参与比赛院校类型
        startTime: "2022-03-20 00:00:00",
        // 开始时间
        sort: 0,
        //排序
        id: "",
        //序号
        formProcessId: "",
        //报名表所属流程
        agreement: "",
        //专家承诺书
        remake: "",
        partyType: "1",
        majorId: "",
        //专业大类
        maxPartyNum: "1",
        //参赛人数
        auditEndTime: "2022-04-08 23:59:59",
        //
        workFormRuleList: [],
        materialRuleList: []
      },
      rules: {
        matchName: [{
          required: true,
          message: "请输入项目名称。",
          trigger: "blur"
        }],
        matchType: [{
          required: true,
          message: "请选择项目类型。",
          trigger: "change"
        }],
        majorId: [{
          required: true,
          message: "请选择专业大类。",
          trigger: "change"
        }],
        matchYear: [{
          required: true,
          message: "请选择项目年份。",
          trigger: "change"
        }],
        auditEndTime: [{
          required: true,
          message: "请选择结束时间。",
          trigger: "change"
        }],
        partyType: [{
          required: true,
          message: "请选择参赛类型。",
          trigger: "change"
        }],
        partyTeamNum: [{
          required: true,
          message: "请输入报名组数",
          trigger: "blur"
        }]
      }
    };
  },
  methods: {
    // 获取项目类型下拉列表
    getTypeList: function getTypeList() {
      var _this = this;
      (0, _public.selectList)({
        businessTypeId: "3"
      }).then(function (res) {
        _this.typeList = res.data;
      });
    },
    // 获取专业大类
    getMajorType: function getMajorType() {
      var _this2 = this;
      (0, _projectType.majorType)().then(function (res) {
        _this2.majorList = res.data;
        console.log(res.data, "da");
      });
    },
    // 提交
    submit: function submit(v) {
      var _this3 = this;
      this.$refs[v].validate(function (valid) {
        if (_this3.form.startTime == "") {
          _this3.$message.error("请填写报名开始时间");
          return false;
        }
        if (_this3.form.endTime == "") {
          _this3.$message.error("请填写报名结束时间");
          return false;
        }
        if (valid) {
          var time1 = new Date(_this3.form.startTime).getTime();
          var time2 = new Date(_this3.form.endTime).getTime();
          var time3 = new Date(_this3.form.auditEndTime).getTime();
          if (time2 < time1) {
            _this3.$message.error("报名结束时间应大于报名开始时间");
            return false;
          }
          if (time3 < time2) {
            _this3.$message.error("审核结束时间应大于报名结束时间");
            return false;
          }
          if (_this3.$route.query.id !== undefined) {
            // 编辑
            (0, _projectType.updataMatch)(_this3.form).then(function (res) {
              _this3.$message.success("操作成功。");
              _this3.$router.push("/object/object");
            });
          } else {
            // 新增
            (0, _project.projectAdd)(_this3.form).then(function (res) {
              if (res.code === 2000) {
                _this3.$message.success("操作成功。");
                _this3.$router.push("/object/object");
              }
            });
          }
        }
      });
    },
    // 返回
    isBack: function isBack() {
      this.$router.push("/object/object");
    },
    // 编辑
    editForm: function editForm() {}
  },
  created: function created() {
    var _this4 = this;
    var v = this.$route.query.id;
    if (v !== undefined) {
      this.$route.meta.title = "编辑项目";
      (0, _projectType.getMatchById)({
        id: v
      }).then(function (res) {
        _this4.form = res.data;
        _this4.form.materialListParamList = res.data.materialRuleList;
        _this4.form.matchWorkFormRuleList = res.data.workFormRuleList;
        _this4.form.partyType = JSON.stringify(_this4.form.partyType);
      });
    } else {
      this.$route.meta.title = "新增项目";
    }
    // 获取专业类别
    this.getMajorType();
    // 获取项目级别类别
    this.getTypeList();
    // 项目类型列表
    (0, _projectType.projectTypeListAll)().then(function (res) {
      var data = res.data;
      _this4.list = data.list;
    });
  }
};